var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!this.$auth0.isLoading)?[_c('NavigationBar'),_c('router-view')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }